<template>
  <div>
    <AdWells v-if="type === 'wells'" :url="url" :img="img"></AdWells>
  </div>
</template>

<script>
import AdWells from "@/components/archive/ads/Wells.vue";

export default {
  components: {
    AdWells
  },
  name: "Ad",
  data() {
    return {
      type: ws_vue_store['config'].archive_ad,
      'url' : ws_vue_store['ad'].url,
      'img' : ws_vue_store['ad'].img
    };
  },
  created() {},
  methods: {}
};
</script>
